import { Link } from "react-router-dom";
import { FaInstagram, FaXTwitter, FaYoutube, FaTiktok, FaImdb, FaFacebook } from "react-icons/fa6";
import { FOOTER } from "../../constants/siteTestIds";
import { BRAND } from "../../data/siteContent";

const SEO_LINKS = [
  ["Relationship Commentary", "/topics/relationship-commentary"],
  ["Dating Advice", "/topics/dating-advice"],
  ["Modern Relationships", "/topics/modern-relationships"],
  ["Gender Dynamics", "/topics/gender-dynamics"],
  ["Men and Women", "/topics/men-and-women"],
  ["Culture Commentary", "/topics/culture-commentary"],
  ["Podcast Host", "/topics/podcast-host"],
  ["Media Personality", "/topics/media-personality"],
  ["Author", "/topics/author"],
];

const SOCIAL_ITEMS = [
  { tid: FOOTER.instagram, label: "Instagram", icon: <FaInstagram size={16} />, href: BRAND.socials.instagram },
  { tid: FOOTER.twitter, label: "X / Twitter", icon: <FaXTwitter size={16} />, href: BRAND.socials.twitter },
  { tid: "footer-social-facebook", label: "Facebook", icon: <FaFacebook size={16} />, href: "https://www.facebook.com/officialmanuelsantana" },
  { tid: "footer-social-tiktok", label: "TikTok", icon: <FaTiktok size={16} />, href: BRAND.socials.tiktok },
  { tid: FOOTER.youtube, label: "YouTube", icon: <FaYoutube size={16} />, href: BRAND.socials.youtube },
  { tid: "footer-social-imdb", label: "IMDb", icon: <FaImdb size={20} />, href: "https://www.imdb.com/name/nm18563041/" },
];

export const Footer = () => {
  return (
    <footer
      id="contact"
      data-testid={FOOTER.section}
      className="relative bg-white border-t border-black/10 pt-20 pb-10"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <div className="grid grid-cols-12 gap-8 mb-16">
          <div className="col-span-12 md:col-span-4">
            <p className="font-mono-ui text-[10px] tracking-[0.3em] uppercase text-black/40 mb-4">
              — <span className="text-accent-red">iammanuelsantana.com</span>
            </p>
            <h3 className="font-display text-[#0a0a0a] text-4xl md:text-5xl tracking-[-0.02em]">
              Manuel
              <br />
              <span className="font-light text-black/45">Santana.</span>
            </h3>
            <p className="mt-6 text-sm text-black/55 max-w-xs">
              Media personality, podcast host and author. Based between {BRAND.cities.join(", ")}.
            </p>
            <p className="mt-6 font-mono-ui text-[10px] tracking-[0.25em] uppercase text-black/40">
              All handles: <span className="text-accent-red">@iammanuelsantana</span>
            </p>
          </div>

          <div className="col-span-6 md:col-span-2">
            <p className="font-mono-ui text-[10px] tracking-[0.3em] uppercase text-black/40 mb-5">Site</p>
            <ul className="space-y-3 text-black/75 text-sm">
              <li><Link to="/" className="link-underline">Home</Link></li>
              <li><Link to="/about" className="link-underline">About</Link></li>
              <li><Link to="/bio" className="link-underline">Biography</Link></li>
              <li><Link to="/podcast" className="link-underline">Podcast</Link></li>
              <li><Link to="/books" className="link-underline">Books</Link></li>
              <li><Link to="/speaking" className="link-underline">Speaking</Link></li>
              <li><Link to="/projects" className="link-underline">Projects</Link></li>
              <li><Link to="/contact" className="link-underline">Contact</Link></li>
              <li><Link to="/press-kit" className="link-underline">Press Kit</Link></li>
            </ul>
          </div>

          <div className="col-span-6 md:col-span-3">
            <p className="font-mono-ui text-[10px] tracking-[0.3em] uppercase text-black/40 mb-5">Topics</p>
            <ul className="space-y-3 text-black/75 text-sm">
              {SEO_LINKS.map(([label, href]) => (
                <li key={href}>
                  <Link to={href} className="link-underline">{label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="col-span-12 md:col-span-3">
            <p className="font-mono-ui text-[10px] tracking-[0.3em] uppercase text-black/40 mb-5">Contact</p>
            <ul className="space-y-3 text-black/75 text-sm">
              <li><a className="link-underline" href={`mailto:${BRAND.emails.media}`}>{BRAND.emails.media}</a></li>
              <li><a className="link-underline" href={`mailto:${BRAND.emails.podcast}`}>{BRAND.emails.podcast}</a></li>
              <li><a className="link-underline" href={`mailto:${BRAND.emails.business}`}>{BRAND.emails.business}</a></li>
              <li><a className="link-underline" href={`mailto:${BRAND.emails.general}`}>{BRAND.emails.general}</a></li>
            </ul>

            <p className="font-mono-ui text-[10px] tracking-[0.3em] uppercase text-black/40 mt-8 mb-4">Follow @iammanuelsantana</p>
            <div className="flex items-center gap-3 flex-wrap">
              {SOCIAL_ITEMS.map((s) => (
                <a
                  key={s.label}
                  data-testid={s.tid}
                  href={s.href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={s.label}
                  title={s.label}
                  className="w-10 h-10 border border-black/20 hover:bg-[#C8102E] hover:border-[#C8102E] hover:text-white text-[#0a0a0a] flex items-center justify-center transition-colors"
                >
                  {s.icon}
                </a>
              ))}
            </div>

            <p className="font-mono-ui text-[10px] tracking-[0.3em] uppercase text-black/40 mt-8 mb-4">Projects</p>
            <div className="flex flex-col gap-2">
              <a href={BRAND.external.podcast} target="_blank" rel="noreferrer"
                 className="inline-flex items-center justify-between border border-black/20 hover:bg-[#0a0a0a] hover:text-white hover:border-[#0a0a0a] px-4 py-3 font-mono-ui text-[10px] tracking-[0.2em] uppercase transition-colors">
                <span>Podcast</span>
                <span className="text-[#C8102E] group-hover:text-white">→</span>
              </a>
              <a href={BRAND.external.book} target="_blank" rel="noreferrer"
                 className="inline-flex items-center justify-between border border-black/20 hover:bg-[#0a0a0a] hover:text-white hover:border-[#0a0a0a] px-4 py-3 font-mono-ui text-[10px] tracking-[0.2em] uppercase transition-colors">
                <span>The Book</span>
                <span className="text-[#C8102E]">→</span>
              </a>
              <a href={BRAND.external.meetToKeep} target="_blank" rel="noreferrer"
                 className="inline-flex items-center justify-between border border-black/20 hover:bg-[#0a0a0a] hover:text-white hover:border-[#0a0a0a] px-4 py-3 font-mono-ui text-[10px] tracking-[0.2em] uppercase transition-colors">
                <span>Meet to Keep</span>
                <span className="text-[#C8102E]">→</span>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-black/10 pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="font-mono-ui text-[10px] tracking-[0.3em] uppercase text-black/40">
            © {new Date().getFullYear()} Manuel Santana — All rights reserved.
          </p>
          <p className="font-mono-ui text-[10px] tracking-[0.3em] uppercase text-black/30">
            {BRAND.cities.join(" · ")}
          </p>
        </div>
      </div>
    </footer>
  );
};
